import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { usePixlieTheme } from '../../../lib/v2/ThemeProvider';

export const ThemeToggle: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { theme, toggleTheme } = usePixlieTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <button
      type="button"
      aria-label="Toggle light / dark theme"
      onClick={toggleTheme}
      className={[
        'inline-flex h-9 w-9 items-center justify-center rounded-[var(--radius-md)]',
        'border border-[var(--border-subtle)] bg-[var(--surface-1)]',
        'text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--surface-2)]',
        'transition-colors duration-[var(--duration-fast)]',
        className,
      ].join(' ')}
    >
      {mounted && theme === 'dark' ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
    </button>
  );
};

export default ThemeToggle;
